import { API_URL } from '@/consts';

import {
  keepPreviousData,
  UndefinedInitialDataOptions,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

export const PIT_DATA_KEY_FACTORY = (id?: string) => ['pit', id];

export const fetchPitData = async (
  id: string
): Promise<{
  url: string;
  filename: string;
}> => {
  const data = await fetch(`${API_URL}/api/self-service/pit/${id}/info`, {
    headers: {
      accept: 'application/json',
    },
  });

  if (!data.ok) {
    throw new Error('Failed to fetch pit data');
  }

  return data.json();
};

export const pitDataQueryOptions = (id: string | undefined) =>
  ({
    queryKey: PIT_DATA_KEY_FACTORY(id),
    queryFn: ({ queryKey }) => fetchPitData(queryKey[1] as string),
    retry: false,
    staleTime: Infinity,
    enabled: !!id,
    throwOnError: true,
    placeholderData: keepPreviousData,
  }) as UndefinedInitialDataOptions<
    { url: string; filename: string },
    Error,
    { url: string; filename: string },
    (string | undefined)[]
  >;
export const usePitDataQuery = () => {
  const { id } = useParams();

  return useQuery(pitDataQueryOptions(id));
};

// post self-service.tax-returns.pit.download params url returned blob
export const downloadPit = async (id: string, url: string): Promise<Blob> => {
  const response = await fetch(`${API_URL}/api/self-service/pit/${id}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ url }),
  });

  if (!response.ok) {
    throw new Error('Failed to download pit');
  }

  return response.blob();
};

export const useDownloadPit = () => {
  const { id } = useParams();

  return useMutation({
    mutationFn: (url: string) => downloadPit(id as string, url),
  });
};
